import { render, staticRenderFns } from "./PurchaseEdit.vue?vue&type=template&id=45d38d02&scoped=true&"
import script from "./PurchaseEdit.vue?vue&type=script&lang=js&"
export * from "./PurchaseEdit.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseEdit.vue?vue&type=style&index=0&id=45d38d02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d38d02",
  null
  
)

export default component.exports